/* 🛒 IAS CRO pack JS (spec: docs/IAS_SHOPIFY_CRO_QA.md, Deck ⑤ 10-12) — PDP only.
   P1 Move 2: prefer a buyable "Ships Now" variant as the selected default — honest:
   driven purely by live variant availability + the variant's own title; falls back to
   Made-for-You when no Ships Now color has real units (never fakes stock).
   P2 Move 4: sticky mobile ATC bar, visible only while the real ATC is off-screen.
   Fails closed: any missing piece → do nothing. */
(function () {
  'use strict';
  if (window.__iasCroInit) return;
  window.__iasCroInit = 1;
  if (!/\/products\//.test(location.pathname)) return;

  /* SWATCH P0 (10-15): this file is `defer` — at its run time readyState is already 'interactive' but the
     LATER deferred scripts (media-gallery.js, pickup-availability.js) haven't defined their elements, so an
     immediate variant change crashed Dawn's onVariantChange (default variant stayed in the form → wrong
     cart line). Wait for DOMContentLoaded (fires after every deferred script); 'load' = fallback; run once. */
  function ready(fn) {
    var done = false;
    function once() { if (done) return; done = true; fn(); }
    if (document.readyState === 'complete') return once();
    document.addEventListener('DOMContentLoaded', once);
    window.addEventListener('load', once);
  }

  function variantData(picker) {
    try {
      var s = picker.querySelector('script[type="application/json"]');
      return s ? JSON.parse(s.textContent) : null;
    } catch (e) { return null; }
  }

  /* P1 Move 2 — Ships-Now default. Skip when the URL pins a variant (?variant=):
     a shared/ad link's choice is respected. */
  function shipsNowDefault() {
    if (/[?&]variant=/.test(location.search)) return;
    var picker = document.querySelector('variant-radios, variant-selects');
    if (!picker) return;
    var variants = variantData(picker);
    if (!variants || !variants.length) return;
    var idInput = document.querySelector('form[data-type="add-to-cart-form"] input.product-variant-id');
    var currentId = idInput ? parseInt(idInput.value, 10) : null;
    var current = variants.find(function (v) { return v.id === currentId; });
    if (current && /ships now/i.test(current.title)) return;        // already on a Ships Now option
    var target = variants.find(function (v) { return v.available && /ships now/i.test(v.title); });
    if (!target) return;                                             // honest fallback: stay on Made for You
    var opts = [target.option1, target.option2, target.option3];
    var fieldsets = picker.querySelectorAll('fieldset');
    if (fieldsets.length) {
      fieldsets.forEach(function (fs, i) {
        if (opts[i] == null) return;
        var input = Array.prototype.find.call(fs.querySelectorAll('input[type="radio"]'), function (r) { return r.value === opts[i]; });
        if (input) input.checked = true;
      });
    } else {
      picker.querySelectorAll('select').forEach(function (sel, i) { if (opts[i] != null) sel.value = opts[i]; });
    }
    picker.dispatchEvent(new Event('change', { bubbles: true }));
    /* SWATCH P0 (10-15) truth weld: the cart must get exactly what the swatch shows. If any
       listener failed mid-change, the hidden id would keep the old default — force it to match. */
    document.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]').forEach(function (input) {
      if (String(input.value) !== String(target.id)) {
        input.value = target.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  /* P2 Move 4 — sticky mobile ATC */
  function stickyAtc() {
    var atc = document.querySelector('.product-form__submit');
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!atc || !form || !('IntersectionObserver' in window)) return;
    var titleEl = document.querySelector('.product__title h1, h1.product__title, .product__info-container h1');
    var priceEl = document.querySelector('.product__info-container .price__regular .price-item--regular, .product__info-container .price-item--sale, .product__info-container .price-item--regular');
    var bar = document.createElement('div');
    bar.className = 'ias-satc';
    bar.innerHTML = '<span class="ias-satc__meta"><span class="ias-satc__title"></span><span class="ias-satc__price"></span></span>' +
      '<button type="button" class="ias-satc__btn"></button>';
    document.body.appendChild(bar);
    var btn = bar.querySelector('.ias-satc__btn');
    function sync() {
      bar.querySelector('.ias-satc__title').textContent = titleEl ? titleEl.textContent.trim() : '';
      bar.querySelector('.ias-satc__price').textContent = priceEl ? priceEl.textContent.trim() : '';
      btn.textContent = atc.textContent.trim() || 'Add to cart';
      btn.disabled = atc.disabled;
    }
    sync();
    new MutationObserver(sync).observe(atc, { childList: true, subtree: true, attributes: true });
    btn.addEventListener('click', function () { if (!atc.disabled) atc.click(); });
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('on', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -40px 0px' }).observe(atc);
  }

  ready(function () {
    shipsNowDefault();
    stickyAtc();
  });
})();
